import { Link } from 'react-router-dom';
import { usePageTitle } from 'utils/pageTitle';

import './AcceptableUsePolicy.css';

export default function SmsTerms() {
	usePageTitle('SMS Terms of Service');
	return (
		<div className="use-policy-container">
			<div className="use-policy">
				<h1>Violerts SMS Terms of Service</h1>

				<p>Last updated: June 24, 2026</p>

				<p>
					These SMS Terms (&quot;Terms&quot;) govern the Violerts text-message notification program (the &quot;Program&quot;), operated by Violerts Inc. (&quot;Violerts,&quot; &quot;we,&quot; &quot;us,&quot; &quot;our&quot;). By enrolling in the Program you agree to these Terms and to our{' '}
					<Link to="/use-policy">Privacy Policy</Link>.
				</p>

				<h2>1. Program description</h2>
				<p>The Program sends recurring automated SMS alerts about new violations and related items on the properties you monitor in your Violerts account.</p>

				<h2>2. How to enroll</h2>
				<p>You enroll by checking the SMS consent box and providing your mobile number on violerts.com (at sign-up or in your notification settings). Providing your mobile number is optional and is not a condition of purchasing any goods or services from us.</p>

				<h2>3. Message frequency</h2>
				<p>Recurring messages; message frequency varies based on activity detected on your monitored properties.</p>

				<h2>4. Cost</h2>
				<p>Message and data rates may apply according to your mobile plan. Violerts does not charge a fee for the messages themselves.</p>

				<h2>5. Opt out</h2>
				<p>Reply STOP to any message to unsubscribe at any time. You will receive a single confirmation message and then no further messages, unless you re-enroll. The keywords STOP, UNSUBSCRIBE, CANCEL, END, and QUIT are honored. You can also turn alerts off in your notification settings.</p>

				<h2>6. Help</h2>
				<p>Reply HELP for help, or email admin@violerts.com.</p>

				<h2>7. Supported carriers</h2>
				<p>The Program is compatible with major U.S. carriers, including AT&amp;T, T-Mobile, and Verizon, among others. Carrier participation and support may change without notice.</p>

				<h2>8. Carrier liability</h2>
				<p>Carriers are not liable for delayed or undelivered messages.</p>

				<h2>9. Privacy</h2>
				<p>
					Your mobile information — including your phone number and your SMS opt-in and consent — will never be shared with, sold to, rented to, or transferred to any third party or affiliate for any purpose, including marketing or promotional purposes. Service providers that act strictly on our behalf to deliver the messages you requested may process this information only to send those messages. See our{' '}
					<Link to="/use-policy">Privacy Policy</Link> for details.
				</p>

				<h2>10. Eligibility</h2>
				<p>You must be the account holder or otherwise authorized to use the mobile number you provide, and you must be at least 18 years old (or the age of majority in your jurisdiction).</p>

				<h2>11. Changes to these Terms</h2>
				<p>We may update these Terms from time to time. The &quot;Last updated&quot; date above reflects the most recent version. Your continued enrollment after a change constitutes acceptance of the updated Terms.</p>

				<h1>Contact</h1>
				<p>Violerts — admin@violerts.com</p>
			</div>
		</div>
	);
}
